import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { BookButton } from './BookButton';
import { FlagStripe } from './BranchBar';
import { navLinks } from '../data/homepage';
export function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);
  return <header className={`fixed inset-x-0 top-0 z-50 bg-navy transition-[box-shadow,background-color] duration-200 ease-out ${scrolled ? 'bg-navy/95 shadow-[0_1px_0_rgba(201,162,39,0.35)] backdrop-blur' : ''}`} data-id="element-179" data-mp="2bd0ka6w65cmm">
      <FlagStripe data-id="element-180" data-mp="2ehbyrt4ovth8" />
      <div className={`mx-auto flex max-w-7xl items-center justify-between px-6 transition-[height] duration-200 ease-out md:px-10 ${scrolled ? 'h-16' : 'h-20 md:h-24'}`} data-id="element-181" data-mp="2ekzqcmqkq5tb">
        <a href="/" aria-label="Veterans For Life home" className="shrink-0" data-id="element-182" data-mp="2oeqefqisge8h">
          <Logo compact={scrolled} data-id="element-183" data-mp="1qv5gme1jwxda" />
        </a>

        <nav aria-label="Main" className="hidden items-center gap-8 lg:flex" data-id="element-184" data-mp="1vrvx32h9puz8">
          <ul className="flex items-center gap-8" data-id="element-185" data-mp="20rib3e4x7f93">
            {navLinks.map(link => <li key={link.label} data-id="element-186" data-mp="25i8eiltsd815">
                <a href={link.href} className="whitespace-nowrap text-base font-medium text-paper/90 transition-colors duration-150 ease-out hover:text-gold" data-id="element-187" data-mp="25igvaot14xhm">
                  {link.label}
                </a>
              </li>)}
          </ul>
          <BookButton size="md" data-id="element-188" data-mp="1506lzm5w9j7f" />
        </nav>

        <div className="flex items-center gap-4 lg:hidden" data-id="element-189" data-mp="14yvgnhwsw3e7">
          <BookButton size="md" className="hidden md:inline-flex" data-id="element-190" data-mp="101dcs5xn4ed2" />
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'} className="inline-flex h-12 w-12 items-center justify-center rounded-sm text-paper" data-id="element-191" data-mp="1erks4cscph9j">
            {open ? <XIcon className="h-7 w-7" data-id="element-192" data-mp="h4u5lm6ed0j5" /> : <MenuIcon className="h-7 w-7" data-id="element-193" data-mp="w0jrzlfhvfoe" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-194" data-mp="vy70ohnujsyo">
        {open && <motion.nav id="mobile-menu" aria-label="Mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-gold/30 bg-navy px-6 pb-8 pt-4 lg:hidden" data-id="element-195" data-mp="r173yxcw02k8">
            <ul className="flex flex-col" data-id="element-196" data-mp="2eyy76rjfht1a">
              {navLinks.map(link => <li key={link.label} className="border-b border-paper/10" data-id="element-197" data-mp="2ewv9rmfy4xmj">
                  <a href={link.href} onClick={() => setOpen(false)} className="block py-4 text-xl font-medium text-paper" data-id="element-198" data-mp="2119kde5swbtl">
                    {link.label}
                  </a>
                </li>)}
            </ul>
            <BookButton fullWidth className="mt-6" data-id="element-199" data-mp="2xrtmshoseuj4" />
          </motion.nav>}
      </AnimatePresence>
    </header>;
}